(function($) {
    $('[data-tags-input]').each(function() {
        var $this = $(this);
        var options = {
            width: '100%',
            defaultText: '',
            minChars: 3
        };
        if ($this.attr('data-tags-input-autocomplete')) {
            options.autocomplete_url = $this.attr('data-tags-input-autocomplete');
        }
        $this.tagsInput(options);
    });
})(jQuery);
